import { Text, useMainContext } from '../../../../modules/Dashboard'
import { usePredictContext } from '../../context/PredictContextProvider'
import { useNavigate } from 'react-router-dom'
import { ReactComponent as StarVector } from '../../assets/analyze-type-bg.svg'

// Icons
import AssistantIcon from '../AssistantIcon'
import { useGetAssistantCategories } from '../../services/usePredict'
import PairImg from '../PairImg'
import SingleStarIcon from '../../../../components/icons/SingleStarIcon'
import RocketIcon from '../../../../components/icons/RocketIcon'
import LockedAssistant from '../LockedAssistant'

const CategorizedAssistant = ({ allAssistants }) => {
    const {
        main: { lang },
    } = useMainContext()

    const { isLocked, assistant, step, setTicker, setTimeFrame, setResponseType } = usePredictContext()
    const navigate = useNavigate()

    const { data: categories, isLoading: loading } = useGetAssistantCategories()

    const handleSelectAssistant = (item) => {
        if (isLocked) return
        const assistantItem = allAssistants.find(a => a?.value === item.assistant)
        if (!assistantItem) return
        assistant.setAssistant(assistantItem)
        setTimeFrame(item?.frame || "")
        setResponseType('complete')

        setTicker(item.ticker.toUpperCase())
        step.setCurrentStep("result")
        navigate(`/analyze/assistant/${assistantItem.tickerCase}?step=result`)
    }

    return (
        <div className="flex flex-col gap-10">

            {loading
                ? Array.from({ length: 6 }).map((_, i) => <SkeletonCategory key={i} />)
                : categories?.map((category, catIdx) => (
                    <div key={category.id} className="flex flex-col gap-4">

                        {/* Category Title */}
                        <div className="flex items-center gap-2">
                            <span className="text-2xl text-white">{category.label}</span>
                            {category.emoji && <span>{category.emoji}</span>}
                        </div>

                        {/* Assistant List - Horizontal Scroll */}
                        <div className="flex flex-col md:flex-row gap-4 md:overflow-x-auto scrollbar-thin scrollbar-thumb-gray-700 py-2">
                            {category.list.map((item, index) => (
                                <div
                                    key={item.ticker + index}
                                    className={`${catIdx % 2 !== 0 ? "bg-gradient-to-b from-[#1F56F9] to-[#6618E3]" : "bg-[#1E1533]"}
                                        min-w-full md:min-w-[350px] border border-purpleBorderDark shine-btn
                                        rounded-2xl py-6 px-7 flex items-center justify-between gap-3 relative overflow-hidden`}
                                >
                                    <div className='absolute top-0 left-0 w-full'>
                                        {/* If Is Locked */}
                                        <LockedAssistant />
                                    </div>
                                    <StarVector className="absolute top-0 left-0 z-[1] " />
                                    <div className={`flex flex-col gap-3 ${isLocked ? "mt-3" : ""}`}>
                                        <div className="flex items-center gap-3">
                                            <PairImg ticker={item.ticker} />
                                            <span className="text-white">
                                                <p>
                                                    {item.ticker}
                                                </p>
                                                <p className='uppercase text-xs text-[#99A1AF]'>
                                                    {item.ticker}
                                                </p>
                                            </span>
                                        </div>

                                        <span className="bg-gradient-to-r from-[#F0B100] to-[#FF6900] flex gap-1 items-center px-2 py-1 rounded-lg max-w-max shadow-sm">
                                            <SingleStarIcon size={12} />
                                            <Text tid={item.assistant} className='text-xs' />
                                        </span>
                                    </div>
                                    <button
                                        className='relative z-[2] flex items-center gap-2 bg-white/20 border border-white/30 rounded-lg px-3 py-1 cursor-pointer transition-all '
                                        onClick={() => handleSelectAssistant(item)}
                                    >
                                        <RocketIcon />
                                        <Text tid={"lunch"} />
                                    </button>
                                </div>
                            ))}
                        </div>

                    </div>
                ))
            }
        </div>
    )
}

export default CategorizedAssistant

const SkeletonCategory = () => (
    <div className="flex flex-col gap-4">
        <div className="h-5 bg-gray-700 rounded w-32 animate-pulse"></div>
        <div className="flex gap-4 overflow-x-auto py-2">
            {Array.from({ length: 3 }).map((_, i) => (
                <div
                    key={i}
                    className="min-w-[260px] bg-[#262433] rounded-xl p-4 h-[140px] animate-pulse"
                ></div>
            ))}
        </div>
    </div>
)
